"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TrendingDown = _interopRequireDefault(require("@material-ui/icons/TrendingDown"));
var _TrendingUp = _interopRequireDefault(require("@material-ui/icons/TrendingUp"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _classes = require("../../utils/classes");
var _Typography = _interopRequireDefault(require("../Typography"));
var _Badge = _interopRequireDefault(require("../Badge"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    content: {
      alignItems: 'flex-end',
      display: 'flex',
      padding: theme.spacing(0.5, 0)
    },
    header: {
      '& svg': {
        position: 'absolute'
      },
      alignItems: 'center',
      display: 'flex',
      position: 'relative',
      width: '100%'
    },
    root: {
      backgroundColor: theme.palette.white,
      borderRadius: '4px',
      display: 'inline-block',
      minWidth: '107px',
      padding: theme.spacing(1),
      position: 'relative'
    },
    secondaryValue: {
      paddingLeft: theme.spacing(1)
    },
    title: {
      overflow: 'hidden',
      paddingLeft: theme.spacing(2),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    titleNoLegend: {
      paddingLeft: theme.spacing(0)
    }
  };
});
var defaultProps = {
  classes: {},
  dataMetrics: {
    root: 'fuse_kpi_card'
  }
};

/*
 * KPI cards can be used to display key metrics on a page.
 */
var _ref = /*#__PURE__*/_react["default"].createElement(_TrendingUp["default"], null);
var _ref2 = /*#__PURE__*/_react["default"].createElement(_TrendingDown["default"], null);
var KpiCard = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var bottomValue = props.bottomValue,
    _props$classes = props.classes,
    propClasses = _props$classes === void 0 ? {} : _props$classes,
    className = props.className,
    dataMetrics = props.dataMetrics,
    legendColor = props.legendColor,
    legendLabel = props.legendLabel,
    primaryValue = props.primaryValue,
    secondaryValue = props.secondaryValue,
    width = props.width;
  var classes = (0, _classes.mergeClasses)(useStyles(), propClasses);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var secondaryValueComp = function secondaryValueComp(secValue) {
    if ((0, _lodash.isEmpty)(secValue) || !secValue.value) return null;
    return secValue.isTrend ? /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
      icon: secValue.isUp ? _ref : _ref2,
      label: secValue.value,
      status: secValue.trendColor === 'red' ? 'error' : 'ok' || 'error',
      variant: "light"
    }) : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "caption",
      color: "textSecondary"
    }, secValue.value);
  };
  if (!primaryValue) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: (0, _classnames["default"])(classes.root, className),
    style: {
      width: width
    },
    "data-metrics": mergedDataMetrics.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.header
  }, legendColor && /*#__PURE__*/_react["default"].createElement("svg", {
    height: 24,
    width: 16
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 6,
    cy: 12,
    "data-automation-id": "legend-color",
    fill: legendColor,
    r: 6
  })), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: (0, _classnames["default"])(classes.title, (0, _defineProperty2["default"])({}, classes.titleNoLegend, !legendColor)),
    variant: "overline",
    color: "textSecondary"
  }, legendLabel)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h4",
    color: "textPrimary"
  }, primaryValue), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.secondaryValue
  }, secondaryValueComp(secondaryValue))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.bottom
  }, secondaryValueComp(bottomValue)));
});
KpiCard.defaultProps = defaultProps;
KpiCard.displayName = 'KpiCard';
KpiCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Configure the bottom label and the kind of value is
   */
  bottomValue: _propTypes["default"].shape({
    isTrend: _propTypes["default"].bool,
    isUp: _propTypes["default"].bool,
    trendColor: _propTypes["default"].oneOf(['red', 'green']),
    value: _propTypes["default"].string
  }),
  /**
   * Override or extend the styles applied to the component. See [CSS API](https://material-ui.com/api/circular-progress/#css-api) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Set the color of the legend Icon.
   */
  legendColor: _propTypes["default"].string,
  /**
   * Title or main legend of the card
   */
  legendLabel: _propTypes["default"].string,
  /**
   * Main value of the card
   */
  primaryValue: _propTypes["default"].string,
  /**
   * Configure the secondary Value and the kind of value is
   */
  secondaryValue: _propTypes["default"].shape({
    isTrend: _propTypes["default"].bool,
    isUp: _propTypes["default"].bool,
    trendColor: _propTypes["default"].oneOf(['red', 'green']),
    value: _propTypes["default"].string
  }),
  /**
   * Manually set the width of the badge
   */
  width: _propTypes["default"].string
} : {};
var _default = KpiCard;
exports["default"] = _default;